// extracted by mini-css-extract-plugin
export default {"notificationList":"NotificationList_notificationList__6Zhy-"};